export default {
  'pages.login.success': 'Login successful!',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.username.placeholder': 'Username',
  'pages.login.username.required': 'Please enter your username!',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please enter your password!',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password?',
  'pages.login.forgotPasswordInfo':
    'Please contact administrator to reset password',
  'pages.login.submit': 'Login',
  'pages.login.back': 'Back',
  'pages.login.emailCheck.title': 'Email Verification',
  'pages.login.emailCheck.description':
    'A 6-digit code has been sent to {email}',
  'pages.login.emailCheck.sent':
    'A verification code has been sent to your email',
  'pages.login.tfaCheck.title': 'Two-Factor Authentication',
  'pages.login.tfaCheck.description':
    'Enter the 6-digit code from your authenticator app',
  'pages.login.verifyCode.submit': 'Verify',
  'pages.login.verifyCode.invalid': 'Invalid verification code',
  'pages.login.oidc.divider': 'Or continue with',
  'pages.login.oidc.continueWith': 'Continue with {provider}',
  'pages.login.oidc.authFailed': 'OIDC login failed',
  'pages.devices.list': 'Device List',
  'pages.devices.os': 'OS',
  'pages.devices.status': 'Status',
  'pages.devices.user': 'User',
  'pages.devices.deviceGroup': 'Group',
  'pages.devices.note': 'Note',
  'pages.devices.online': 'Online',
  'pages.devices.offline': 'Offline',
  'pages.devices.days': 'days',
  'pages.devices.hours': 'hours',
  'pages.devices.minutes': 'minutes',
  'pages.devices.justNow': 'just now',
  'pages.devices.enable': 'Enable',
  'pages.devices.disable': 'Disable',
  'pages.devices.enableSuccess': 'Device enabled',
  'pages.devices.enableFailed': 'Failed to enable device',
  'pages.devices.disableSuccess': 'Device disabled',
  'pages.devices.disableFailed': 'Failed to disable device',
  'pages.devices.deleteSuccess': 'Device deleted',
  'pages.devices.deleteFailed': 'Failed to delete device',
  'pages.devices.deleteConfirm': 'Are you sure to delete this device?',
  'pages.devices.deviceInfo': 'username@device_name',
  'pages.devices.strategyInfo': 'Strategy Info',
  'pages.devices.device': 'Device',
  'pages.devices.strategy': 'Strategy',
  'pages.devices.info': 'Info',
  'pages.devices.statusNormal': 'Normal',
  'pages.devices.statusDisabled': 'Disabled',
  'pages.devices.onlineStatus': 'Online Status',
  'pages.devices.deviceGroupSearchTip': 'Filter by device group name',
  'pages.devices.remove': 'Remove',
  'pages.devices.removeFromGroupSuccess': 'Device removed from group',
  'pages.devices.removeFromGroupFailed': 'Failed to remove device from group',
  'pages.devices.removeFromGroupConfirm':
    'Are you sure to remove this device from the group?',
  'pages.devices.batchRemove': 'Batch Remove',
  'pages.devices.batchRemoveFromGroupSuccess':
    'Successfully removed {count} device(s) from group',
  'pages.devices.batchRemoveFromGroupFailed':
    'Failed to remove devices from group',
  'pages.devices.batchRemoveFromGroupConfirm':
    'Are you sure to remove selected devices from the group?',
  'pages.devices.batchEnable': 'Batch Enable',
  'pages.devices.batchDisable': 'Batch Disable',
  'pages.devices.batchEnableConfirm':
    'Are you sure to enable selected devices?',
  'pages.devices.batchDisableConfirm':
    'Are you sure to disable selected devices?',
  'pages.devices.batchEnableSuccess': 'Successfully enabled {count} device(s)',
  'pages.devices.batchEnableFailed': 'Failed to enable devices',
  'pages.devices.batchEnablePartialFailed':
    'Successfully enabled {success} device(s), {failed} failed',
  'pages.devices.batchDisableSuccess':
    'Successfully disabled {count} device(s)',
  'pages.devices.batchDisableFailed': 'Failed to disable devices',
  'pages.devices.batchDisablePartialFailed':
    'Successfully disabled {success} device(s), {failed} failed',
  'pages.devices.edit': 'Edit Device',
  'pages.devices.updateSuccess': 'Device updated',
  'pages.devices.updateFailed': 'Failed to update device',
  'pages.devices.selectUser': 'Select user',
  'pages.devices.selectDeviceGroup': 'Select device group',
  'pages.devices.selectStrategy': 'Select strategy',
  'pages.addressBook.name': 'Name',
  'pages.addressBook.note': 'Note',
  'pages.addressBook.shared': 'Shared Address Books',
  'pages.addressBook.create': 'Create Address Book',
  'pages.addressBook.edit': 'Edit Address Book',
  'pages.addressBook.personal': 'Personal Address Book',
  'pages.addressBook.addPeer': 'Add',
  'pages.addressBook.addTag': 'Add Tag',
  'pages.addressBook.tagName': 'Tag Name',
  'pages.addressBook.tagAdded': 'Tag added',
  'pages.addressBook.tagAddFailed': 'Failed to add tag',
  'pages.addressBook.tagDeleted': 'Tag deleted',
  'pages.addressBook.tagDeleteFailed': 'Failed to delete tag',
  'pages.addressBook.deleteTagConfirm': 'Are you sure to delete this tag?',
  'pages.addressBook.tagModeUnion': 'Any',
  'pages.addressBook.tagModeIntersection': 'All',
  'pages.addressBook.importDevices': 'Import Devices',
  'pages.addressBook.importSuccess': 'Successfully imported {count} device(s)',
  'pages.addressBook.importPartialFailed': '{count} device(s) failed to import',
  'pages.addressBook.createSuccess': 'Address book created',
  'pages.addressBook.createFailed': 'Failed to create address book',
  'pages.addressBook.updateSuccess': 'Address book updated',
  'pages.addressBook.updateFailed': 'Failed to update address book',
  'pages.addressBook.deleteSuccess': 'Address book(s) deleted',
  'pages.addressBook.deleteFailed': 'Failed to delete address book(s)',
  'pages.addressBook.deleteConfirm':
    'Are you sure to delete this address book?',
  'pages.addressBook.batchDeleteConfirm':
    'Are you sure to delete selected address books?',
  'pages.addressBook.device': 'Device',
  'pages.addressBook.alias': 'Alias',
  'pages.addressBook.tags': 'Tags',
  'pages.addressBook.peerAdded': 'Peer added',
  'pages.addressBook.peerAddFailed': 'Failed to add peer',
  'pages.addressBook.peerDeleted': 'Peer deleted',
  'pages.addressBook.peerDeleteFailed': 'Failed to delete peer',
  'pages.addressBook.deletePeerConfirm': 'Are you sure to delete this peer?',
  'pages.addressBook.import': 'Import',
  'pages.addressBook.recycleBin': 'Recycle Bin',
  'pages.deviceGroups.list': 'Device Groups',
  'pages.deviceGroups.name': 'Name',
  'pages.deviceGroups.note': 'Note',
  'pages.deviceGroups.create': 'Create Device Group',
  'pages.deviceGroups.edit': 'Edit Device Group',
  'pages.deviceGroups.createSuccess': 'Device group created',
  'pages.deviceGroups.createFailed': 'Failed to create device group',
  'pages.deviceGroups.updateSuccess': 'Device group updated',
  'pages.deviceGroups.updateFailed': 'Failed to update device group',
  'pages.deviceGroups.deleteSuccess': 'Device group deleted',
  'pages.deviceGroups.deleteFailed': 'Failed to delete device group',
  'pages.deviceGroups.deleteConfirm':
    'Are you sure to delete this device group?',
  'pages.deviceGroups.import': 'Import',
  'pages.deviceGroups.importDevices': 'Import Devices',
  'pages.deviceGroups.importSuccess': 'Successfully imported {count} device(s)',
  'pages.deviceGroups.importFailed': 'Failed to import devices',
  'pages.users.list': 'User List',
  'pages.users.name': 'Name',
  'pages.users.email': 'Email',
  'pages.users.note': 'Note',
  'pages.users.status': 'Status',
  'pages.users.create': 'Create User',
  'pages.users.enable': 'Enable',
  'pages.users.disable': 'Disable',
  'pages.users.enableSuccess': 'User enabled',
  'pages.users.enableFailed': 'Failed to enable user',
  'pages.users.disableSuccess': 'User disabled',
  'pages.users.disableFailed': 'Failed to disable user',
  'pages.users.createSuccess': 'User created',
  'pages.users.createFailed': 'Failed to create user',
  'pages.users.deleteSuccess': 'User deleted',
  'pages.users.deleteFailed': 'Failed to delete user',
  'pages.users.deleteConfirm': 'Are you sure to delete this user?',
  'pages.audits.conn': 'Connection Audits',
  'pages.audits.file': 'File Transfer Logs',
  'pages.audits.alarm': 'Alarm Audits',
  'pages.audits.console': 'Console Audits',
  'pages.audits.requestedAt': 'Requested At',
  'pages.audits.establishedAt': 'Established At',
  'pages.audits.closedAt': 'Closed At',
  'pages.audits.from': 'From',
  'pages.audits.fromName': 'From Name',
  'pages.audits.to': 'To',
  'pages.audits.toName': 'To Name',
  'pages.audits.action': 'Action',
  'pages.audits.time': 'Time',
  'pages.audits.alarmType': 'Alarm Type',
  'pages.audits.user': 'User',
  'pages.audits.detail': 'Detail',
  'pages.audits.type': 'Type',
  'pages.audits.connType.remoteDesktop': 'Remote Desktop',
  'pages.audits.connType.fileTransfer': 'File Transfer',
  'pages.audits.connType.portTransfer': 'Port Transfer',
  'pages.audits.connType.viewCamera': 'View Camera',
  'pages.audits.connType.terminal': 'Terminal',
  'pages.audits.connType.notLoggedIn': 'Not Logged In',
  'pages.audits.duration': 'Duration',
  'pages.audits.note': 'Note',
  'pages.audits.disconnect': 'Disconnect',
  'pages.audits.disconnectSuccess': 'Successfully disconnected!',
  'pages.audits.disconnectFailed': 'Disconnect failed!',
  'pages.audits.disconnectConfirmTitle': 'Confirm Operation',
  'pages.audits.disconnectConfirmTip':
    'Are you sure you want to disconnect this device?',
  'pages.audits.updateSuccess': 'Update is successful',
  'pages.audits.updateFailed': 'Update failed, please try again!',
  'pages.audits.exportCSV': 'Export CSV',
  'pages.audits.noDataToExport': 'No data to export',
  'pages.audits.exportSuccess': 'Export successful',
  'pages.audits.exportFailed': 'Export failed',
  'pages.audits.exportConfirmTitle': 'Export CSV',
  'pages.audits.exportConfirmContent': 'Export up to 1000 records. Continue?',
  'pages.audits.remote': 'Remote',
  'pages.audits.local': 'Local',
  'pages.audits.direction': 'Direction',
  'pages.audits.files': 'Files',
  'pages.audits.remoteTip': 'Remotely controlled computer or terminal',
  'pages.audits.remoteSearchTip': 'Search by remote device ID (fuzzy match)',
  'pages.audits.remotePlaceholder': 'Enter remote device ID',
  'pages.audits.pathTip': 'Path of Remote Device',
  'pages.audits.exportCsvTip': 'Export up to 1000 records at a time',
  'pages.audits.limitedTip': 'Show the 10 largest files by size',
  'pages.audits.startTime': 'Start Time',
  'pages.audits.endTime': 'End Time',
  'pages.common.action': 'Action',
  'pages.common.delete': 'Delete',
  'pages.common.edit': 'Edit',
  'pages.common.batchDelete': 'Batch Delete',
  'pages.common.download': 'Download',
  'pages.common.more': 'More',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist',
  'pages.404.buttonText': 'Back to Home',
  'pages.customClients.list': 'Custom Client List',
  'pages.customClients.name': 'Client Name',
  'pages.customClients.createdAt': 'Created At',
  'pages.customClients.create': 'Create Custom Client',
  'pages.customClients.edit': 'Edit Custom Client',
  'pages.customClients.deleteConfirm':
    'Are you sure to delete this custom client?',
  'pages.customClients.createSuccess': 'Custom client created',
  'pages.customClients.createFailed': 'Failed to create custom client',
  'pages.customClients.updateSuccess': 'Custom client updated',
  'pages.customClients.updateFailed': 'Failed to update custom client',
  'pages.customClients.deleteSuccess': 'Custom client deleted',
  'pages.customClients.deleteFailed': 'Failed to delete custom client',
  'pages.customClients.downloadFailed': 'Failed to download client',
  'pages.userGroups.list': 'User Group List',
  'pages.userGroups.name': 'Group Name',
  'pages.userGroups.note': 'Note',
  'pages.userGroups.userCount': 'User Count',
  'pages.userGroups.create': 'Create User Group',
  'pages.userGroups.edit': 'Edit User Group',
  'pages.userGroups.deleteConfirm': 'Are you sure to delete this user group?',
  'pages.userGroups.createSuccess': 'User group created',
  'pages.userGroups.createFailed': 'Failed to create user group',
  'pages.userGroups.updateSuccess': 'User group updated',
  'pages.userGroups.updateFailed': 'Failed to update user group',
  'pages.userGroups.deleteSuccess': 'User group deleted',
  'pages.userGroups.deleteFailed': 'Failed to delete user group',
  'pages.roles.list': 'Role List',
  'pages.roles.name': 'Role Name',
  'pages.roles.note': 'Note',
  'pages.roles.permissions': 'Permissions',
  'pages.roles.permissionsInfo': 'Number of assigned permissions',
  'pages.roles.create': 'Create Role',
  'pages.roles.edit': 'Edit Role',
  'pages.roles.deleteConfirm': 'Are you sure to delete this role?',
  'pages.roles.selectPermissions': 'Select Permissions',
  'pages.roles.createSuccess': 'Role created successfully',
  'pages.roles.createFailed': 'Failed to create role',
  'pages.roles.updateSuccess': 'Role updated successfully',
  'pages.roles.updateFailed': 'Failed to update role',
  'pages.roles.deleteSuccess': 'Role deleted successfully',
  'pages.roles.deleteFailed': 'Failed to delete role',
  'pages.settings.title': 'System Settings',
  'pages.settings.save': 'Save Settings',
  'pages.settings.general': 'General Settings',
  'pages.settings.siteName': 'Site Name',
  'pages.settings.adminEmail': 'Admin Email',
  'pages.settings.language': 'Default Language',
  'pages.settings.security': 'Security Settings',
  'pages.settings.enable2FA': 'Enable Two-Factor Authentication',
  'pages.settings.sessionTimeout': 'Session Timeout (minutes)',
  'pages.settings.maxLoginAttempts': 'Max Login Attempts',
  'pages.settings.advanced': 'Advanced Settings',
  'pages.settings.logLevel': 'Log Level',
  'pages.settings.enableDebugMode': 'Enable Debug Mode',
  'pages.settings.fetchFailed': 'Failed to load settings',
  'pages.settings.saveSuccess': 'Settings saved successfully',
  'pages.settings.saveFailed': 'Failed to save settings',
  'pages.strategies.list': 'Strategy List',
  'pages.strategies.name': 'Strategy Name',
  'pages.strategies.note': 'Note',
  'pages.strategies.status': 'Status',
  'pages.strategies.create': 'Create Strategy',
  'pages.strategies.edit': 'Edit Strategy',
  'pages.strategies.deleteConfirm': 'Are you sure to delete this strategy?',
  'pages.strategies.createSuccess': 'Strategy created',
  'pages.strategies.createFailed': 'Failed to create strategy',
  'pages.strategies.updateSuccess': 'Strategy updated',
  'pages.strategies.updateFailed': 'Failed to update strategy',
  'pages.strategies.deleteSuccess': 'Strategy deleted',
  'pages.strategies.deleteFailed': 'Failed to delete strategy',
  'pages.strategies.enterName': 'Enter strategy name',
  'pages.strategies.configSummary': 'Config',
  'pages.strategies.configCount': '{modified}/{total} modified',
  'pages.strategies.modifiedAt': 'Modified At',
  'pages.strategies.createdAt': 'Created At',
  'pages.strategies.configOptions': 'Configuration Options',
  'pages.strategies.defaultLabel': 'Default',
  'pages.strategies.defaultValue': 'Default: {value}',
  'pages.strategies.resetToDefault': 'Reset to default',
  'pages.strategies.modifiedSummary': '{count} config(s) modified',
  'pages.strategies.resetAll': 'Reset All',
  'pages.strategies.assign': 'Assign',
  'pages.strategies.assignManagement': 'Assign Management',
  'pages.strategies.assignDevice': 'Device',
  'pages.strategies.assignUser': 'User',
  'pages.strategies.assignDeviceGroup': 'Device Group',
  'pages.strategies.assignedTargets': 'Assigned Targets',
  'pages.strategies.noAssigned': 'No assigned targets',
  'pages.strategies.addAssignment': 'Add Assignment',
  'pages.strategies.selectTarget': 'Select target',
  'pages.strategies.assignSuccess': 'Strategy assigned successfully',
  'pages.strategies.assignFailed': 'Failed to assign strategy',
  'pages.strategies.assignPartialFailed':
    'Assigned {success} target(s), {failed} failed: {errors}',
  'pages.strategies.unassignSuccess': 'Strategy unassigned successfully',
  'pages.strategies.unassignFailed': 'Failed to unassign strategy',
  'pages.strategies.unassignConfirm': 'Unassign this target?',
  'pages.strategies.fetchDetailFailed': 'Failed to fetch strategy details',
  'pages.strategies.updatedAt': 'Updated At',
  'pages.strategies.category.connection': 'Connection & Access',
  'pages.strategies.category.security': 'Security & Auth',
  'pages.strategies.category.display': 'Display & UI',
  'pages.strategies.category.av': 'Audio/Video & Codec',
  'pages.strategies.category.file': 'File & Clipboard',
  'pages.strategies.category.advanced': 'Advanced',
  'pages.strategies.category.floating': 'Floating Window',
  'pages.strategies.category.privacy': 'Privacy & Recording',
  'pages.strategies.category.hide': 'UI Hiding',
  'pages.users.inviteSuccess': 'Invitation sent',
  'pages.users.inviteFailed': 'Failed to send invitation',
  'pages.users.active': 'Active',
  'pages.users.disabled': 'Disabled',
  'pages.users.unverified': 'Unverified',
  'pages.users.roles': 'Roles',
  'pages.users.rolesInfo': 'User roles and permissions',
  'pages.users.strategy': 'Strategy',
  'pages.users.strategyInfo': 'Connection strategy for user',
  'pages.users.group': 'Group',
  'pages.users.groupInfo': 'User group assignment',
  'pages.users.groupName': 'Device Group',
  'pages.users.invite': 'Invite User',
  'pages.users.password': 'Password',
  'pages.users.isAdmin': 'Admin',
  'pages.users.normalUser': 'Normal',
  'pages.users.statusInfo': 'User account status',
  'pages.users.edit': 'Edit User',
  'pages.users.updateSuccess': 'User updated',
  'pages.users.updateFailed': 'Failed to update user',
  'pages.users.security': 'Security',
  'pages.users.securitySettings': 'Security Settings',
  'pages.users.securityUpdateSuccess': 'Security settings updated',
  'pages.users.securityUpdateFailed': 'Failed to update security settings',
  'pages.users.tfaEnforce': 'Enforce Two-Factor Authentication',
  'pages.users.emailVerification': 'Require Email Verification',
  'pages.users.forceLogout': 'Logout',
  'pages.users.forceLogoutSuccess': 'Force logout successful',
  'pages.users.forceLogoutFailed': 'Failed to force logout',
  'pages.users.thirdAuthType': 'Auth Type',
  'pages.users.createdAt': 'Created At',
  'pages.users.batchEnable': 'Batch Enable',
  'pages.users.batchDisable': 'Batch Disable',
  'pages.users.batchForceLogout': 'Batch Force Logout',
  'pages.users.batchEnableConfirm': 'Are you sure to enable selected users?',
  'pages.users.batchDisableConfirm': 'Are you sure to disable selected users?',
  'pages.users.batchForceLogoutConfirm':
    'Are you sure to force logout selected users?',
  'pages.users.batchEnableSuccess': 'Successfully enabled {count} user(s)',
  'pages.users.batchEnableFailed': 'Failed to enable users',
  'pages.users.batchEnablePartialFailed':
    'Successfully enabled {success} user(s), {failed} failed',
  'pages.users.batchDisableSuccess': 'Successfully disabled {count} user(s)',
  'pages.users.batchDisableFailed': 'Failed to disable users',
  'pages.users.batchDisablePartialFailed':
    'Successfully disabled {success} user(s), {failed} failed',
  'pages.users.batchForceLogoutSuccess': 'Batch force logout successful',
  'pages.users.batchForceLogoutFailed': 'Failed to force logout users',
  'pages.dashboard.totalUsers': 'Total Users',
  'pages.dashboard.activeUsers': 'Active Users',
  'pages.dashboard.totalDevices': 'Total Devices',
  'pages.dashboard.onlineDevices': 'Online Devices',
  'pages.dashboard.offlineDevices': 'Offline Devices',
  'pages.dashboard.todayConnections': 'Today Connections',
  'pages.dashboard.activeConnections': 'Active Connections',
  'pages.dashboard.avgDuration': 'Avg Duration',
  'pages.dashboard.totalAlarms': 'Total Alarms',
  'pages.dashboard.criticalAlarms': 'Critical Alarms',
  'pages.dashboard.userDistribution': 'User Distribution',
  'pages.dashboard.adminUsers': 'Admin Users',
  'pages.dashboard.normalUsers': 'Normal Users',
  'pages.dashboard.deviceDistribution': 'Device Distribution',
  'pages.dashboard.connectionAnalysis': 'Connection Analysis',
  'pages.dashboard.successRate': 'Success Rate',
  'pages.dashboard.failureCount': 'Failure Count',
  'pages.dashboard.totalDuration': 'Total Duration',
  'pages.dashboard.fileTransfer': 'File Transfer',
  'pages.dashboard.transferredToday': 'Transferred Today',
  'pages.dashboard.totalSize': 'Total Size',
  'pages.dashboard.uploadCount': 'Upload Count',
  'pages.dashboard.downloadCount': 'Download Count',
  'pages.dashboard.systemStatus': 'System Status',
  'pages.dashboard.uptime': 'Uptime',
  'pages.dashboard.trendData': 'Trend Data',
  'pages.dashboard.connectionTrend': 'Connection Trend',
  'pages.dashboard.userActiveTrend': 'User Active Trend',
  'pages.dashboard.alarmTrend': 'Alarm Trend',
  'pages.dashboard.recentEvents': 'Recent Events',
  'pages.dashboard.user': 'User',
  'pages.dashboard.device': 'Device',
  'pages.dashboard.duration': 'Duration',
  'pages.dashboard.startTime': 'Start Time',
  'pages.dashboard.eventType': 'Type',
  'pages.dashboard.action': 'Action',
  'pages.dashboard.target': 'Target',
  'pages.dashboard.status': 'Status',
  'pages.dashboard.time': 'Time',
  'pages.common.pleaseEnterName': 'Please enter name',
  'pages.common.pleaseEnterPeerId': 'Please enter peer ID',
  'pages.common.pleaseEnterTagName': 'Please enter tag name',
  'pages.common.pleaseEnterUsername': 'Please enter username',
  'pages.common.pleaseEnterEmail': 'Please enter email',
  'pages.common.pleaseEnterValidEmail': 'Please enter valid email',
  'pages.common.pleaseEnterPassword': 'Please enter password',
  'pages.common.pleaseEnterRoleName': 'Please enter role name',
  'pages.common.id': 'ID',
  'pages.dashboard.min': 'min',
  'pages.dashboard.cpu': 'CPU',
  'pages.dashboard.memory': 'Memory',
  'pages.dashboard.disk': 'Disk',
  'pages.dashboard.inactive': 'Inactive',
  'pages.dashboard.onlineRate': 'Online Rate',
  'pages.dashboard.connectionCount': 'Count',
  'pages.dashboard.newUsers': 'New Users',
  'pages.dashboard.7days': '7 Days',
  'pages.dashboard.30days': '30 Days',
  'pages.dashboard.90days': '90 Days',
  'pages.dashboard.noData': 'No data',
  'pages.dashboard.resourceDistribution': 'Resource Distribution',
  'pages.dashboard.operationAnalysis': 'Operation Analysis',
  'pages.smtp.title': 'SMTP Configuration',
  'pages.smtp.description':
    'Configure SMTP mail server for sending system notification emails',
  'pages.smtp.host': 'Server Address',
  'pages.smtp.hostPlaceholder': 'Please enter SMTP server address',
  'pages.smtp.port': 'Port',
  'pages.smtp.portPlaceholder': 'Please enter port number',
  'pages.smtp.secure': 'Use SSL/TLS',
  'pages.smtp.secureHelp':
    'Enable secure connection (usually port 465 uses SSL, port 587 uses TLS)',
  'pages.smtp.user': 'Username',
  'pages.smtp.userPlaceholder': 'Please enter SMTP authentication username',
  'pages.smtp.password': 'Password',
  'pages.smtp.passwordPlaceholder': 'Please enter SMTP authentication password',
  'pages.smtp.from': 'Sender Email',
  'pages.smtp.fromPlaceholder': 'Please enter sender email address',
  'pages.smtp.enabled': 'Enable Configuration',
  'pages.smtp.enabledHelp':
    'When enabled, this configuration will be used to send system emails',
  'pages.smtp.testConnection': 'Test Connection',
  'pages.smtp.testSuccess': 'SMTP connection test successful',
  'pages.smtp.testFailed': 'SMTP connection test failed',
  'pages.smtp.saveSuccess': 'SMTP configuration saved successfully',
  'pages.smtp.saveFailed': 'Failed to save SMTP configuration',
  'pages.smtp.createdAt': 'Created At',
  'pages.smtp.updatedAt': 'Updated At',
  'pages.addressBook.color': 'Color',
  'pages.addressBook.deviceInfo': 'username@device_name',
  'pages.addressBook.manageTags': 'Manage Tags',
  'pages.addressBook.newTagName': 'New Tag Name',
  'pages.addressBook.peerUpdateFailed': 'Failed to update peer',
  'pages.addressBook.peerUpdated': 'Peer updated',
  'pages.addressBook.renameTag': 'Rename Tag',
  'pages.addressBook.selectTags': 'Select tags',
  'pages.addressBook.tagColorUpdateFailed': 'Failed to update tag color',
  'pages.addressBook.tagRenameFailed': 'Failed to rename tag',
  'pages.addressBook.tagRenamed': 'Tag renamed',
  'pages.addressBook.untagged': 'Untagged',
  'pages.common.cancel': 'No',
  'pages.common.confirm': 'Yes',
  'pages.common.enterDescription': 'Enter description',
  'pages.common.rename': 'Rename',
  'pages.common.save': 'Save',
  'pages.customClients.enterName': 'Enter client name',
  'pages.settings.chinese': 'Chinese',
  'pages.settings.english': 'English',
  'pages.settings.enterAdminEmail': 'Enter admin email',
  'pages.settings.enterSiteName': 'Enter site name',
  'pages.settings.logError': 'Error',
  'pages.settings.logInfo': 'Info',
  'pages.settings.logWarning': 'Warning',
  'pages.userGroups.enterName': 'Enter group name',
  'pages.users.admin': 'Admin',
  'pages.users.me': 'Me',
  'pages.oidcProviders.list': 'OIDC Providers',
  'pages.oidcProviders.name': 'Provider Name',
  'pages.oidcProviders.type': 'Type',
  'pages.oidcProviders.issuer': 'Issuer URL',
  'pages.oidcProviders.clientId': 'Client ID',
  'pages.oidcProviders.clientSecret': 'Client Secret',
  'pages.oidcProviders.scope': 'Scope',
  'pages.oidcProviders.authorizationEndpoint': 'Authorization Endpoint',
  'pages.oidcProviders.tokenEndpoint': 'Token Endpoint',
  'pages.oidcProviders.userinfoEndpoint': 'Userinfo Endpoint',
  'pages.oidcProviders.jwksUri': 'JWKS URI',
  'pages.oidcProviders.enabled': 'Enabled',
  'pages.oidcProviders.priority': 'Priority',
  'pages.oidcProviders.endpointConfig': 'Endpoint Configuration',
  'pages.oidcProviders.create': 'Create Provider',
  'pages.oidcProviders.edit': 'Edit Provider',
  'pages.oidcProviders.test': 'Test',
  'pages.oidcProviders.testResult': 'Test Connection Result',
  'pages.oidcProviders.discoveredEndpoints': 'Discovered Endpoints',
  'pages.oidcProviders.enterName': 'Enter provider name',
  'pages.oidcProviders.enterIssuer': 'Enter issuer URL',
  'pages.oidcProviders.enterClientId': 'Enter client ID',
  'pages.oidcProviders.enterClientSecret': 'Enter client secret',
  'pages.oidcProviders.enterEndpoint': 'Auto-discovered if empty',
  'pages.oidcProviders.createSuccess': 'OIDC provider created',
  'pages.oidcProviders.createFailed': 'Failed to create OIDC provider',
  'pages.oidcProviders.updateSuccess': 'OIDC provider updated',
  'pages.oidcProviders.updateFailed': 'Failed to update OIDC provider',
  'pages.oidcProviders.deleteSuccess': 'OIDC provider deleted',
  'pages.oidcProviders.deleteFailed': 'Failed to delete OIDC provider',
  'pages.oidcProviders.deleteConfirm': 'Are you sure to delete this provider?',
  'pages.oidcProviders.enableSuccess': 'OIDC provider enabled',
  'pages.oidcProviders.enableFailed': 'Failed to enable OIDC provider',
  'pages.oidcProviders.disableSuccess': 'OIDC provider disabled',
  'pages.oidcProviders.disableFailed': 'Failed to disable OIDC provider',
  'pages.oidcProviders.enableConfirm': 'Are you sure to enable this provider?',
  'pages.oidcProviders.disableConfirm':
    'Are you sure to disable this provider?',
  'pages.oidcProviders.testFailed': 'Failed to test OIDC connection',
  'pages.oidcProviders.fetchDetailFailed': 'Failed to fetch provider details',
  'pages.account.tab.basic': 'Basic Information',
  'pages.account.tab.avatar': 'Avatar',
  'pages.account.tab.security': 'Security',
  'pages.account.basicInfo.title': 'Basic Information',
  'pages.account.basicInfo.name': 'Username',
  'pages.account.basicInfo.email': 'Email',
  'pages.account.basicInfo.note': 'Note',
  'pages.account.basicInfo.updateSuccess': 'Profile updated successfully',
  'pages.account.basicInfo.updateFailed': 'Failed to update profile',
  'pages.account.avatar.title': 'Avatar Settings',
  'pages.account.avatar.hint':
    'Supports JPG, PNG, WebP, max 2MB, will be resized to 256x256',
  'pages.account.avatar.upload': 'Upload Avatar',
  'pages.account.avatar.delete': 'Delete Avatar',
  'pages.account.avatar.deleteConfirm': 'Are you sure to delete your avatar?',
  'pages.account.avatar.uploadSuccess': 'Avatar uploaded successfully',
  'pages.account.avatar.uploadFailed': 'Failed to upload avatar',
  'pages.account.avatar.deleteSuccess': 'Avatar deleted successfully',
  'pages.account.avatar.deleteFailed': 'Failed to delete avatar',
  'pages.account.avatar.fileTooLarge': 'File size cannot exceed 2MB',
  'pages.account.avatar.invalidFormat':
    'Only JPG, PNG, WebP formats are supported',
  'pages.account.security.title': 'Security Settings',
  'pages.account.security.2faStatus': '2FA Status',
  'pages.account.security.2faAction': 'Action',
  'pages.account.security.enabled': 'Enabled',
  'pages.account.security.disabled': 'Disabled',
  'pages.account.security.enable2FA': 'Enable 2FA',
  'pages.account.security.disable2FA': 'Disable 2FA',
  'pages.account.security.setup2FA': 'Setup Two-Factor Authentication',
  'pages.account.security.setupFailed': 'Failed to setup 2FA',
  'pages.account.security.scanQRCode':
    'Scan the QR code with your authenticator app, then enter the verification code below.',
  'pages.account.security.secretKey': 'Secret Key',
  'pages.account.security.verificationCode': 'Verification Code',
  'pages.account.security.enterCode': 'Please enter verification code',
  'pages.account.security.verifyAndEnable': 'Verify & Enable',
  'pages.account.security.enableSuccess': '2FA enabled successfully',
  'pages.account.security.enableFailed': 'Failed to enable 2FA',
  'pages.account.security.currentCode': 'Current Verification Code',
  'pages.account.security.confirmDisable': 'Confirm Disable',
  'pages.account.security.disableSuccess': '2FA disabled successfully',
  'pages.account.security.disableFailed': 'Failed to disable 2FA',
  'pages.account.security.password': 'Login Password',
  'pages.account.security.passwordSet': 'Set',
  'pages.account.security.passwordNotSet': 'Not Set',
  'pages.account.security.changePassword': 'Change Password',
  'pages.account.security.currentPassword': 'Current Password',
  'pages.account.security.enterCurrentPassword':
    'Please enter current password',
  'pages.account.security.newPassword': 'New Password',
  'pages.account.security.enterNewPassword':
    'Please enter new password (min 6 characters)',
  'pages.account.security.confirmNewPassword': 'Confirm New Password',
  'pages.account.security.confirmNewPasswordPlaceholder':
    'Please re-enter new password',
  'pages.account.security.passwordMinLength':
    'Password must be at least 6 characters',
  'pages.account.security.passwordMismatch': 'The two passwords do not match',
  'pages.account.security.changePasswordSuccess':
    'Password changed successfully',
  'pages.account.security.changePasswordFailed': 'Failed to change password',
  'pages.account.security.thirdPartyUser':
    'Third-party login users cannot change password',
  'pages.account.security.noPasswordUser': 'No password set for this account',
};
